import { call, takeLatest, all, put } from '@redux-saga/core/effects';

import {
  SET_FINGERPRINT,
  POST_TRACKING_DETAILS,
} from '../actions/affiliate/affiliateActionConstants';
import {
  setFingerprintRequest,
  saveTrackingDetailsRequest,
} from '../../request/affiliateRequest';
import {
  setFingerprintSuccess,
  setFingerprintError,
  postTrackingDetailsSuccess,
  postTrackingDetailsError,
} from '../actions/affiliate/afilliateActions';
import { formatErrorMessage } from '../../util/helpers/registerRejectErrorCodeHelper';

// Set fingerprint
function* setFingerprint({ payload }) {
  try {
    yield call(setFingerprintRequest, payload);
    yield call(setFingerprintSuccess);
    yield call(setFingerprintError, '');
  } catch (error) {
    console.log(error); // eslint-disable-line
    const errMessage = yield call(formatErrorMessage, error);
    yield call(setFingerprintError, errMessage);
  }
}
function* saveTrackingDetails({ payload }) {
  try {
    const response = yield call(saveTrackingDetailsRequest, payload.data);
    yield put(postTrackingDetailsSuccess(response.data));
    yield put(postTrackingDetailsError(''));
  } catch (error) {
    const e = formatErrorMessage(error);
    yield put(postTrackingDetailsError(e));
  }
}

export default function* accountSaga() {
  yield all([
    takeLatest(SET_FINGERPRINT, setFingerprint),
    takeLatest(POST_TRACKING_DETAILS, saveTrackingDetails),
  ]);
}
